import React from "react";

const Tooltip = ({ visible, x, y, title, rows = [] }) => {
  if (!visible) return null;
  return (
    <div
      style={{
        // position: "absolute",
        left: x,
        top: y,
        // background: "#111827",
        // color: "#f9fafb",
        // padding: "6px 8px",
        // borderRadius: 6,
        // fontSize: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        // pointerEvents: "none",
        // whiteSpace: "nowrap",
        // zIndex: 10,
      }}
      className="absolute bg-white text-black text-xs px-2 py-1 rounded-md z-50"
    >
      <div className="font-semibold">{title}</div>
      {rows.map((r, i) => (
        // <div
        //   key={i}
        //   style={{
        //     display: "flex",
        //     alignItems: "center",
        //     gap: 6,
        //     marginTop: 4,
        //   }}
        // >
        //   <span
        //     style={{
        //       width: 6,
        //       height: 6,
        //       borderRadius: "50%",
        //       background: r.color,
        //       display: "inline-block",
        //     }}
        //   />
        //   <span>
        //     {r.name}: {r.value?.toLocaleString?.() ?? r.value}
        //   </span>
        // </div>
        <div key={i} className="flex items-center justify-between gap-3 mt-1 ">
          <div className="flex items-center gap-1 flex-1 ">
            <span
              style={{
                background: r.color,
              }}
              className="w-2 h-2 rounded-full inline-block"
            />
            {r.name}
            <span className="ml-auto">:</span>
          </div>

          <div className="">{r.value?.toLocaleString?.() ?? r.value}</div>
        </div>
      ))}
    </div>
  );
};

export default Tooltip;
